<template>
    <main v-if="data && data.page">
        <div class="heroCont">
            <div class="hero" v-if="data.page.cover">
                <CopyrightedImage :image="data.page.cover" :width="1200" :height="750" :cover="true" />
            </div>
            <div class="infoBar">
                <WebsiteBreadcrumbs>
                    <span>advocacy</span>
                </WebsiteBreadcrumbs>
            </div>
            <h1 class="helvetica title1">{{ data.page?.title }}</h1>
            <div class="body" v-if="data.page.introduction" v-html="data.page.introduction"></div>
            <div class="downloadsCont" v-if="data.page.downloads.length > 0">
                <BlockDownloads :downloads="data?.page?.downloads.map((download: any) => download.directus_files_id)" />
            </div>
        </div>
        <BlockGrid v-if="data && data.page" :articles="data.page.articles.map((article: any) => article.articles_id)" />

        <BottomBookshop v-if="data.page.bottom_zone == 'bookshop'" />
        <BottomDownloads v-else-if="data.page.bottom_zone == 'downloads' && data?.page?.bottom_downloads.length > 0" :downloads="data?.page?.bottom_downloads" />
        <BottomPositionPapers v-else-if="data.page.bottom_zone == 'position_papers'" :filter="data.page.url" :title="data.page?.title" />

        <WebsiteFooter v-if="data && data.page" />
    </main>
</template>

<script lang="ts" setup>
const { getThemePage } = usePages();
const directusUrl = useDirectusUrl()
const route = useRoute();
const { data } = useAsyncData(`advocacy-${route.params.theme}`, () => getThemePage(route.params.theme));

useSeoMeta({
    title: () => `${data.value?.page?.title} | Advocacy | EIC Federation`,
    ogTitle: () => `${data.value?.page?.title} | Advocacy | EIC Federation`,
    twitterTitle: () => `${data.value?.page?.title} | Advocacy | EIC Federation`,

    description: () => data.value?.page?.summary,
    ogDescription: () => data.value?.page?.summary,
    twitterDescription: () => data.value?.page?.summary,

    ogImage: () => data.value?.page?.cover?.id ? directusUrl + '/assets/' + data.value?.page.cover.id : undefined,
})

</script>

<style lang="scss" scoped>
main {
    padding-top: var(--size-padding-header);

    .heroCont {
        margin: 0 var(--size-margin-page) var(--size-gutter-sections) var(--size-margin-page);
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 0 var(--size-margin-page);

        .hero {
            position: relative;
            margin-bottom: var(--size-gutter-large);
            grid-column: 1 / span 2;
            height: 500px;
        }

        .infoBar {
            margin-bottom: var(--size-gutter-default);
            color: var(--color-primary);

            .date {
                display: flex;
                gap: var(--size-gutter-default);
            }
        }

        h1 {
            grid-column: 1 / span 2;
            margin-bottom: var(--size-gutter-double);
        }

        .body {
            grid-column: 2;
        }

        .downloadsCont {
            grid-column: 2;
            margin-top: var(--size-gutter-double);
        }
    }
}

@media screen and (max-width: 1200px) {
    main {
        .heroCont {

            .body,
            .downloadsCont {
                grid-column: 1 / span 2;
            }
        }
    }
}

@media screen and (max-width: 600px) {
    main {
        .heroCont {
            .body {
                grid-column: 1 / span 2;
            }

            .downloadsCont {
                grid-column: 1 / span 2;
            }
        }
    }
}
</style>